import moment from 'moment'
import React from 'react'
import { useCalendar } from '../CalendarContext'
import CalendarMonthView from '../../MobileCalendarMonth/CalendarMonthView'
import MobileEventTable from './MobileEventTable'

export default function MonthView(_props) {
  const { events, setDate, date } = useCalendar()

  return <CalendarMonthView events={events} date={date} setDate={setDate} TableComponent={MobileEventTable} />
}

MonthView.title = (_: Date) => {
  return ''
}

MonthView.navigate = (date: Date, action: string) => {
  switch (action) {
    case 'PREV':
      return moment(date).subtract(1, 'month').toDate()
    case 'NEXT':
      return moment(date).add(1, 'month').toDate()
    default:
      return date
  }
}
